import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup,  ModalHeader, ModalBody } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { StaticPaymentMethod} from '../Common'


class StaticPaymentModal extends React.Component {

    render() {
        const { t } = this.props
        return (
            <>
                <ModalHeader>{t('add_payment_info')}</ModalHeader>
                <ModalBody>
                    <div className="text-center mb-3">
                        <FormGroup>
                            <StaticPaymentMethod data={this.props.data} onSubmit={this.props.onSubmit}/>
                        </FormGroup>
                    </div>
                    { this.props.error && <div className="error text-center">{this.props.error}</div> }
                </ModalBody>
            </>
        )
    }
}

export default withTranslation('translations')(modalWrapper(true, "StaticPaymentModal")(StaticPaymentModal));